/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-down-arrow': {
    width: 8,
    height: 9,
    viewBox: '0 0 8 9',
    data: '<path pid="0" d="M4.5 1.138a.5.5 0 1 0-1 0h1zm-.854 7.353a.5.5 0 0 0 .708 0l3.182-3.182a.5.5 0 1 0-.708-.707L4 7.43 1.172 4.602a.5.5 0 0 0-.708.707L3.646 8.49zM3.5 1.138v7h1v-7h-1z" _fill="#6D8EB4"/>'
  }
})
